const featureFlags = {
  ENABLE_USER_SUBSCRIPTION: process.env.REACT_APP_ENABLE_USER_SUBSCRIPTION !== "false",
  ENABLE_MERCHANT_SUBSCRIPTION: process.env.REACT_APP_ENABLE_MERCHANT_SUBSCRIPTION !== "false",
};

export default featureFlags;
